import type { OnboardingDraft, OperatingHoursEntry, SubVerticalOption } from "./types";

const STANDARD_HOURS: OperatingHoursEntry[] = [
  { weekday: 0, open: "00:00", close: "00:00", closed: true },
  { weekday: 1, open: "09:00", close: "19:00" },
  { weekday: 2, open: "09:00", close: "19:00" },
  { weekday: 3, open: "09:00", close: "19:00" },
  { weekday: 4, open: "09:00", close: "19:00" },
  { weekday: 5, open: "09:00", close: "20:00" },
  { weekday: 6, open: "10:00", close: "18:00" },
];

const VET_HOURS: OperatingHoursEntry[] = STANDARD_HOURS.map((h) =>
  h.closed ? h : { ...h, open: "08:00", close: "20:00" },
);

export const SUB_VERTICAL_SEED: SubVerticalOption[] = [
  {
    key: "grooming-salon",
    category: "grooming",
    displayName: { tr: "Kuaför Salonu", en: "Grooming Salon" },
    description: { tr: "Yıkama, tıraş, tırnak — slot bazlı.", en: "Wash, cut, nails — slot-based." },
    engineKind: "slot",
    modules: ["scheduling", "customers", "services"],
    defaultOperatingHours: STANDARD_HOURS,
  },
  {
    key: "mobile-grooming",
    category: "mobile-service",
    displayName: { tr: "Mobil Kuaför", en: "Mobile Grooming" },
    description: { tr: "Müşteriye giden hizmet — rota optimizasyonu.", en: "On-site service with route planning." },
    engineKind: "slot",
    modules: ["scheduling", "routes", "customers"],
    defaultOperatingHours: STANDARD_HOURS,
  },
  {
    key: "vet-clinic",
    category: "veterinary",
    displayName: { tr: "Veteriner Klinik", en: "Veterinary Clinic" },
    description: { tr: "Muayene, aşı, cerrahi randevuları.", en: "Consultations, vaccines, surgery." },
    engineKind: "consultation",
    modules: ["scheduling", "medical-records", "prescriptions"],
    defaultOperatingHours: VET_HOURS,
    complianceHints: [{ tr: "Veteriner ruhsatı gereklidir.", en: "Veterinary license required." }],
  },
  {
    key: "boarding-hotel",
    category: "boarding",
    displayName: { tr: "Pansiyon / Otel", en: "Boarding / Hotel" },
    description: { tr: "Gecelik konaklama — kapasite yönetimi.", en: "Overnight stays with capacity planning." },
    engineKind: "nightly",
    modules: ["bookings", "kennels", "feeding-plans"],
    defaultOperatingHours: STANDARD_HOURS,
  },
  {
    key: "daycare",
    category: "daycare",
    displayName: { tr: "Gündüz Bakımı", en: "Daycare" },
    description: { tr: "Gündüz oyun & bakım grupları.", en: "Day play & care groups." },
    engineKind: "event",
    modules: ["bookings", "groups", "report-cards"],
    defaultOperatingHours: STANDARD_HOURS,
  },
  {
    key: "dog-training",
    category: "training",
    displayName: { tr: "Köpek Eğitimi", en: "Dog Training" },
    description: { tr: "Bireysel & grup eğitim seansları.", en: "Private & group training sessions." },
    engineKind: "event",
    modules: ["scheduling", "courses", "progress-notes"],
    defaultOperatingHours: STANDARD_HOURS,
  },
  {
    key: "dog-walking",
    category: "walking",
    displayName: { tr: "Köpek Yürüyüşü", en: "Dog Walking" },
    description: { tr: "Düzenli yürüyüş rutinleri.", en: "Recurring walking routines." },
    engineKind: "slot",
    modules: ["routes", "subscriptions"],
    defaultOperatingHours: STANDARD_HOURS,
  },
  {
    key: "pet-retail",
    category: "retail",
    displayName: { tr: "Pet Mağaza", en: "Pet Retail" },
    description: { tr: "Mağaza + servis kombine işletme.", en: "Combined retail and service shop." },
    engineKind: "slot",
    modules: ["pos", "inventory", "scheduling"],
    defaultOperatingHours: STANDARD_HOURS,
  },
];

export const EMPTY_DRAFT: OnboardingDraft = {
  version: 1,
  updatedAt: new Date().toISOString(),
  account: {
    email: "",
    displayName: "",
    locale: "tr",
    acceptTerms: false,
    marketingOptIn: false,
  },
  business: {
    businessName: "",
    taxId: "",
    countryCode: "TR",
    subVerticalKey: "",
  },
  branch: {
    branchName: "",
    address: { street: "", city: "", district: "", postalCode: "", countryCode: "TR" },
    timezone: "Europe/Istanbul",
    phone: "",
  },
};

export const SAMPLE_DRAFT: OnboardingDraft = {
  ...EMPTY_DRAFT,
  account: {
    email: "ayse@patispa.com",
    displayName: "Ayşe Yılmaz",
    locale: "tr",
    acceptTerms: true,
    marketingOptIn: true,
  },
  business: {
    businessName: "PatiSpa Kuaför",
    taxId: "1234567890",
    countryCode: "TR",
    subVerticalKey: "grooming-salon",
  },
  branch: {
    branchName: "Kadıköy Şube",
    address: { street: "Bahariye Cad. No:42", city: "İstanbul", district: "Kadıköy", postalCode: "34710", countryCode: "TR" },
    timezone: "Europe/Istanbul",
    phone: "+905551234567",
  },
};
